import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { SpeedBumpImage, Wrapper } from './SpeedBumpTile.styles'
import { useTileClick } from '@/hooks/HTMLElementClickHook'

const SpeedBumpTile: React.FC<{ image: string }> = ({ image }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  // const trackTileClicked = useTileClick('Speedbump')

  return (
    <Wrapper
      data-testid="speedbump"
      // Reverting campaign as per BAI-6059
      // onClick={(event) => {
      //   trackTileClicked({
      //     tileTitle: image,
      //     imageUrl: `${baseUrl}/tiles/${image}-desktop.png`,
      //     url: `/en/things-to-do/hot-deals`,
      //     event,
      //   })
      //   router.push('/en/things-to-do/hot-deals')
      // }}
    >
      <SpeedBumpImage baseUrl={baseUrl} image={image} />
    </Wrapper>
  )
}

export default SpeedBumpTile
